var map = {
	"./brand1.png": 6213,
	"./brand2.png": 8382,
	"./brand3.png": 260,
	"./brand4.png": 3355,
	"./brand5.png": 6865,
	"./brand6.png": 5786,
	"./brand7.png": 1347,
	"./brand8.png": 5428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1434;